import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getCookie,delCookie } from '@/utils/auth'

// create an axios instance
// const service = axios.create({
//   baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
//   // withCredentials: true, // send cookies when cross-domain requests
//   timeout: 10000 // request timeout
// })

// request interceptor
axios.interceptors.request.use(
  config => {
    // do something before request is sent
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      let tokenName = 'X-JWT-SUPTOKEN';

      // console.log(config);
      // // 判断接口是不是属于百运调用，是就需要替换token名称
      // let apiUrl = config.url.split('/api')[0].toLowerCase();
      // let isFalse = false;
      // let baiYunApi = ['ict', 'ice', 'ici'];
      // isFalse = baiYunApi.some(item => apiUrl.indexOf(item) != -1);
      // if (isFalse) {
      //   tokenName = 'X-Jwt-Token';
      // }
      console.log("======token===",getCookie("X-JWT-SUPTOKEN"));
      config.headers[tokenName] = getCookie("X-JWT-SUPTOKEN");
      // X-Jwt-Token
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
axios.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data;
    if (res.ErrorCode == "401"  || res.ErrorCode == "AuthenticationFailed" ) {
      //没有携带cooie 忘登录页跳
      window.location.href = "/login";
    }
    //console.log("re======",res);
    //if(!res.IsOK){
    //if (res.ErrorCode !== "C0001") {
    // Message({
    //       message: res.message || 'Error',
    //       type: 'error',
    //       duration: 5 * 1000
    //     })
    // if (res.ErrorCode === "S1002") {
    //       // to re-login
    //       MessageBox.confirm('账号密码错误，请重新输入', '提示', {
    //         confirmButtonText: '确定',
    //         cancelButtonText: '取消',
    //         type: 'warning'
    //       }).then(() => {
    //         store.dispatch('user/resetToken').then(() => {
    //           location.reload()
    //         })
    //       })
    //     }
    //    return Promise.reject(new Error(res.message || 'Error'))
    return res

    // }else{
    //   return res;
    // }

    // if the custom code is not 20000, it is judged as an error.
    // if (res.code !== 20000) {
    //   Message({
    //     message: res.message || 'Error',
    //     type: 'error',
    //     duration: 5 * 1000
    //   })

    //   // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
    //     // to re-login
    //     MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
    //       confirmButtonText: 'Re-Login',
    //       cancelButtonText: 'Cancel',
    //       type: 'warning'
    //     }).then(() => {
    //       store.dispatch('user/resetToken').then(() => {
    //         location.reload()
    //       })
    //     })
    //   }
    //   return Promise.reject(new Error(res.message || 'Error'))
    // } else {
    //   return res
    // }
  },
  error => {
    console.log('err' + error) // for debug
    const { status } = error.response
    console.log("=====拦截器status====",status);
    if (status === 401 || error.response.data.ErrorCode == 'AuthenticationFailed') {
      // todo: 重定向到登录页
      delCookie("X-JWT-SUPTOKEN");
      delCookie("IM-TOKENSUP")
      delCookie("SuplierLoginName")
      sessionStorage.removeItem('MenuInfo');
    }
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    //
    return Promise.reject(error)
  }
)

export default axios
